export const formatDateToMonthYear = (date: string) => {
  return new Intl.DateTimeFormat('en', { month: '2-digit', year: 'numeric' }).format(new Date(date)).replace('/', '.');
};
